export enum ActionCategory {
  SAMPLE = 'sample',
  TEMPERATURE = 'temperature',
  PURGE = 'purge',
  WATER_TREATMENT = 'waterTreatment',
  MAINTENANCE = 'maintenance',
  HUMIDITY = 'humidity',
}
